const postCompaniesStr = {
  toastr: 'Empresa adicionada',
  toastr1: ' foi adicionado com sucesso',
  toastrError: 'Empresa já cadastrado',
  toastrError1: 'Este CNPJ ou Nome já foi cadastrado'
};

export default postCompaniesStr;
